import "./cart.scss";
import { PHP_URL } from "../../config/env";

export default function Overview(props) {
  const { bestellung } = props
  console.log('%c🤪 ~ file: confirmation.js:5 [] -> bestellung : ', 'color: #4bfac5', bestellung);
  const eticketUrl = `${PHP_URL}/e_tickets.php?id=${bestellung.id}&bestellnummer=${bestellung.bestellnummer}`;

  return (
    <div className="cartBox">
      <div className="content">
        <div className="CartContainer text-center">
          <h1> Vielen Dank für deine Bestellung!</h1>
          <p>
            Deine Bestellung war Erfolgreich.
          </p>
          <p>
            {bestellung.hasETickets && (
              <span>
                Deine E-Tickets kannst du <a href={eticketUrl} target="_blank" rel="noreferrer">hier herunterladen</a> und ausdrucken.
              </span>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
